import React from "react";
import Footer from "./../Footer";
import { Link, withRouter } from "react-router-dom";

import { Pages, Settings } from "./Pages";

class Chapter3 extends React.Component {
  constructor(props) {
    super(props);

    this.page = Pages[4];
    this.handleTogglePopout = this.handleTogglePopout.bind(this);

    this.handlePopoutImages = this.handlePopoutImages.bind(this);
    this.popImages = [
      `${process.env.PUBLIC_URL}/images/thumbnail-chapter-3.jpg`,
      `${process.env.PUBLIC_URL}/images/christmas-club.jpg`,
      `${process.env.PUBLIC_URL}/images/statement-of-condition.jpg`
    ];
  }

  handlePopoutImages = e => {
    this.props.popoutImages(e);
  };

  handleTogglePopout = popout => {
    this.props.togglePopout(popout);
  };

  componentDidMount() {
    this.props.bgHoverState(this.page.color);
    this.props.imageObjects(document.querySelectorAll(Settings.imageSelectors));

    this.props.gatherImages(this.popImages);

    document.title = `${this.page.name.replace(
      "<br />",
      ""
    )} | Peapack 100 Anniversary`;
    document.body.className = "page-inner page-chapter-3";
  }

  render() {
    return (
      <div className="page-wrapper">
        <div className="page">
          <div className="header-section wrapper">
            <div className="row">
              <div className="col-left col-md-6">
                <div className="header-content">
                  <Link
                    to="/"
                    onClick={this.props.bgHoverState}
                    className="back-button"
                  >
                    Back
                  </Link>
                  <h1 dangerouslySetInnerHTML={{ __html: this.page.name }} />
                  <div className="caption">
                    Subscribing to Liberty bonds was a symbol of patriotic duty
                    in the United States and introduced the idea of financial
                    security to many citizens for the first time. The Act of
                    Congress authorizing Liberty bonds is still in use as the
                    authority under which all U.S. Treasury bonds are issued.
                    (courtesy of Library of Congress, Prints & Photographs
                    Division, reproduction number cph.3g09574)
                  </div>
                </div>
              </div>
              <div className="col-right col-md-6">
                <figure className="header-thumbnail anim-up">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/peapack-trust-co.jpg`}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
          <div className="white-background entry-content">
            <div className="wrapper">
              <div className="row row10">
                <div className="col-md-8">
                  <p>
                    The Peapack-Gladstone National Bank experienced steady
                    growth between 1921 and 1925. Cashier S. J. Shoemaker
                    recorded that Bank assets had reached $576,328.19 at the
                    close of business on September 28, 1925, by which time
                    surplus stock was valued at $120,000. This sum exceeded the
                    $100,000 minimum State of New Jersey regulatory capital
                    requirement to form a Trust Company. The Board recognized
                    that reorganizing as a Trust Company would allow the Bank to
                    expand its investment services and execute business “arising
                    out of trusts in any form.” On November 30, 1925, the
                    Peapack-Gladstone Trust Company was officially established,
                    formalizing the Bank’s entry into the wealth management
                    business. The Bank’s reorganization was reported in the
                    local newspapers as well as in <em>The New York Times</em>.
                  </p>
                  <p>
                    The Bank solicited new customers and continued its pledge to
                    provide a safe banking facility. In return for their
                    business, depositors received 4% interest on savings
                    deposits; they also could borrow money “on approved
                    security,” store Liberty bonds (which many citizens had
                    purchased to support the Allied cause in World War I) at the
                    Bank “in reasonable amounts without charge,” and purchase
                    traveler's checks. Customers were encouraged to send
                    deposits by mail; prompt acknowledgement of such deposits
                    was guaranteed. A new account could be opened with as little
                    as one dollar, and the Bank assured depositors that “whether
                    large or small your business will receive the same prompt,
                    painstaking and courteous attention.” The Bank’s name may
                    have changed, but customer service and a commitment to the
                    needs of the community were continual.
                  </p>
                  <p>
                    By 1928 the Bank’s “Christmas Club” was in full swing.
                    Christmas Club savings programs were designed to promote the
                    habit of regular saving. The Bank’s Christmas Club was
                    simple and appealing: Deposit a set amount of money ($0.25
                    to $5.00) per week into a special savings account and
                    receive the money back at the end of the year for Christmas
                    shopping. Colorful savings cards made it easy for customers
                    to track their deposits and maintain a weekly routine of
                    putting money aside for the holidays.
                  </p>
                </div>
                <div className="col-md-4">
                  <figure className="img pt-md-10">
                    <div
                      className="popout-image"
                      onClick={this.handlePopoutImages}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/thumbnail-chapter-3.jpg`}
                        alt=""
                      />
                    </div>
                    <figcaption>
                      Peapack-Gladstone Trust Company ink blotter
                      (Peapack-Gladstone Bank archives)
                    </figcaption>
                  </figure>
                </div>
              </div>
              <br />
              <div className="row row10">
                <div className="col-md-8">
                  <figure className="full">
                    <div
                      className="popout-image"
                      onClick={this.handlePopoutImages}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/christmas-club.jpg`}
                        alt=""
                      />
                    </div>
                    <figcaption className="line pt-1 pb-2 mb-5">
                      Christmas Club Cards (Peapack-Gladstone Bank archives)
                    </figcaption>
                  </figure>
                  <p>
                    In the summer of 1928, at the peak of the roaring twenties,
                    Republican Presidential candidate Herbert Hoover was on the
                    campaign trail. The American economy was booming, and Mr.
                    Hoover expressed the jubilance that many of his fellow
                    Americans shared with these words, “We in America are nearer
                    to the final triumph over poverty than ever before in the
                    history of any land. The poorhouse is vanishing from among
                    us.”
                  </p>
                  <p>
                    He won the election, but the country’s sense of optimism
                    proved to be short-lived. In the final days of October 1929,
                    the United States was shaken to its core by a massive stock
                    market panic and a subsequent worldwide depression that
                    persisted into World War II.
                  </p>
                </div>
                <div className="col-md-4">
                  <figure className="full pt-4">
                    <div
                      className="popout-image"
                      onClick={this.handlePopoutImages}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/statement-of-condition.jpg`}
                        alt=""
                      />
                    </div>
                    <figcaption>
                      The June 30, 1929 Peapack-Gladstone Trust Company
                      Statement of Condition, which represents the high point
                      for the Trust Company, coming four months before the Great
                      Depression changed America (Peapack-Gladstone Bank
                      archives)
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <Footer togglePopout={this.handleTogglePopout} />
        </div>
      </div>
    );
  }
}

export default withRouter(Chapter3);
